import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppGuard } from '../../services/auth.guard';
import { ProjetosComponent } from './projetos/projetos.component';
import { CadastrarProjetoComponent } from './cadastrar-projeto/cadastrar-projeto.component';
import { DisciplinaComponent } from './disciplinas/disciplinas.component';
import { CadastrarDisciplinaComponent } from './cadastrar-area/cadastrar-disciplina.component';
import { RevisaoComponent } from './revisao/revisao.component';
import { ListagemValidacaoComponent } from './listagem-validacao/listagem-validacao.component';
import { ValidarProjetoComponent } from './validar-projeto/validar-projeto.component';

const routes: Routes = [
  {
    path: 'engenharia/projetos',
    component: ProjetosComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'], title: 'Projetos | BUILTUP' },
  },
  {
    path: 'engenharia/cadastrar-projeto',
    component: CadastrarProjetoComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'], title: 'Cadastrar Projeto | BUILTUP' },
  },
  {
    path: 'engenharia',
    component: ListagemValidacaoComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'], title: 'Validações | BUILTUP' },
  },
  {
    path: 'engenharia/validar-projeto',
    component: ValidarProjetoComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'], title: 'Validar Projeto | BUILTUP' },
  },
  {
    path: 'engenharia/disciplinas',
    component: DisciplinaComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'], title: 'Disciplinas | BUILTUP' },
  },
  {
    path: 'engenharia/cadastrar-disciplina',
    component: CadastrarDisciplinaComponent,
    canActivate: [AppGuard],
    data: {
      requiredRoles: ['NuAdmin'],
      title: 'Cadastrar Disciplina | BUILTUP',
    },
  },
  {
    path: 'engenharia/revisao',
    component: RevisaoComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'], title: 'Revisão de Projeto | BUILTUP' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class EngenhariaRoutingModule {}
